import { session } from 'feature/widget/SessionStore'
import { makeAutoObservable } from 'mobx'
import { mx } from 'store/base/mx'
import { CLOSE } from 'store/base/mx/MxRef'

export class StandExitModalStore {
  constructor() {
    makeAutoObservable(this)
    session.pause(true)
  }

  [CLOSE]() {
    session.pause(false)
  }
}

export const standExit = mx.ref<StandExitModalStore>()
